import React, { useState } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import RestService from "./../../Restservice";
import { Link } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import { createBrowserHistory } from "history";
import GoogleLogin from "./GoogleLogin";
import GlobalHelmet from "./../../GlobalHelmet";
import Common from "./../../common.json";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(3),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

export default function SignUp() {
  const classes = useStyles();
  const [submitDisabled, setsubmitDisabled] = useState(true);
  const [emailerr, setemailerr] = useState(false);
  const [moberr, setmoberr] = useState("");
  const [mobilenymber, setmobile] = useState(false);
  const [fsubmitDisabled, setfsubmitDisabled] = useState(false);
  const [errmsg, seterrmsg] = useState("");
  const history = createBrowserHistory({ forceRefresh: true });

  const validationSchema = Yup.object().shape({
    otp: Yup.string()
      .required("OTP is required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .test("len", "OTP must be exactly 4 digits", (val) => val.length === 4),
    user_name: Yup.string().required("First Name is required"),
    email: Yup.string().required("Email is required").email("Email is invalid"),
    privacycheck: Yup.bool().oneOf([true], "Accept Ts & Cs is required"),
    mobile: Yup.string()
      .required("Mobile Number is required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .test(
        "len",
        "Mobile Number must be exactly 10 characters",
        (val) => val.length === 10
      ),
  });
  const { register, handleSubmit, reset, errors } = useForm({
    resolver: yupResolver(validationSchema),
  });
  function onSubmit(fdata) {
    // display form data on success
    //alert('SUCCESS!! :-)\n\n' + JSON.stringify(data, null));
    setfsubmitDisabled(true);
    const data = JSON.stringify(fdata, null);
    RestService.registerUser(function (res) {
      const respo = JSON.parse(res);

      setfsubmitDisabled(false);
      if (respo.data.status === 1) {
        localStorage.setItem(
          "userdata",
          JSON.stringify(respo.data.userDetails, null)
        );
        history.push("/");
      } else {
        setemailerr(respo.data.emessage);
        setmoberr(respo.data.mmessage);
      }
      seterrmsg(respo.data.message);
    }, data);
  }

  const resend = (e) => {
    setsubmitDisabled(true);
    RestService.validateMobile(function (res) {
      const response = JSON.parse(res);
      if (response.data.status === 0) {
        setmoberr(response.data.message);
      } else {
        setmoberr("");
        setsubmitDisabled(false);
      }
    }, mobilenymber);
  };
  const validatePhone = (e) => {
    let mobile = e.target.value;
    setsubmitDisabled(true);
    if (mobile.length === 10) {
      setmobile(mobile);
      RestService.validateMobile(function (res) {
        const response = JSON.parse(res);
        if (response.data.status === 0) {
          setmoberr(response.data.message);
        } else {
          setmoberr("");
          setsubmitDisabled(false);
        }
      }, mobile);
    }
  };

  const validateEmail = (e) => {
    let email = e.target.value;

    var pattern = new RegExp(
      /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    );

    if (pattern.test(email)) {
      setTimeout(
        () => {
          RestService.validateEmail(function (res) {
            const response = JSON.parse(res);
            if (response.data.status === 0) {
              setemailerr(response.data.message);
            } else {
              setemailerr("");
            }
          }, email);
        },

        1000
      );
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <GlobalHelmet {...Common.registration} />
      <div className="bodycontainer">
        <div className={"upperRegform " + classes.paper}>
          <Avatar className={classes.avatar}>
            <LockOutlinedIcon />
          </Avatar>
          <Typography component="h1" variant="h5">
            Sign up
          </Typography>
          <form
            className={classes.form + " mb-4"}
            onSubmit={handleSubmit(onSubmit)}
            onReset={reset}
          >
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <input
                  type="text"
                  autoComplete="user_name"
                  name="user_name"
                  variant="outlined"
                  id="user_name"
                  label="Name"
                  placeholder="Enter Your Name"
                  autoFocus
                  ref={register}
                  className={`form-control ${
                    errors.user_name ? "is-invalid" : ""
                  }`}
                />
                <div className="invalid-feedback">
                  {errors.user_name?.message}
                </div>
              </Grid>
              <Grid item xs={12}>
                <input
                  type="text"
                  variant="outlined"
                  id="email"
                  label="Email Address"
                  name="email"
                  placeholder="Enter Email id"
                  autoComplete="email"
                  onKeyUp={validateEmail}
                  ref={register}
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                />
                <div className="error">{emailerr}</div>
                <div className="invalid-feedback">{errors.email?.message}</div>
              </Grid>
              <Grid item xs={12}>
                <input
                  type="text"
                  variant="outlined"
                  id="email"
                  label="Mobile number"
                  name="mobile"
                  autoComplete="mobile"
                  onChange={validatePhone}
                  maxLength="10"
                  ref={register}
                  placeholder="Enter Mobile Number"
                  className={`form-control ${
                    errors.mobile ? "is-invalid" : ""
                  }`}
                />
                {!submitDisabled ? (
                  <span onClick={resend} className="resend">
                    Resend
                  </span>
                ) : (
                  ""
                )}

                <div className="error">{moberr}</div>
                <div className="invalid-feedback">{errors.mobile?.message}</div>
              </Grid>
              <Grid item xs={12}>
                <input
                  variant="outlined"
                  name="otp"
                  label="OTP"
                  type="text"
                  id="otp"
                  maxLength="4"
                  ref={register}
                  disabled={submitDisabled}
                  placeholder="Enter OTP"
                  className={`form-control ${errors.otp ? "is-invalid" : ""}`}
                />
                <div className="invalid-feedback">{errors.otp?.message}</div>
              </Grid>
              <Grid item xs={12}>
                <label>
                  <input
                    type="checkbox"
                    value="1"
                    name="privacycheck"
                    className={` ${errors.privacycheck ? "is-invalid" : ""}`}
                    color="primary"
                    ref={register}
                    required
                  />
                </label>
                <Link to="/privacy-policy" target="_blank">
                  Privacy Policy.
                </Link>
                <div className="error">{errors.privacycheck?.message}</div>
              </Grid>
            </Grid>
            <div className="error">{errmsg} </div>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={fsubmitDisabled}
              className={classes.submit}
            >
              Sign Up
            </Button>

            <Grid container justify="flex-end">
              <Grid item>
                <Link to="/login/" variant="body2">
                  Already have an account? Sign in
                </Link>
              </Grid>
            </Grid>
          </form>
          <GoogleLogin />

          <div className="mt-100"></div>
        </div>
      </div>
    </Container>
  );
}
